import {
  GET_REPORTING_REASONS_ASYNC,
  RESTORE_DEFAULT_REASONS_ASYNC,
  UPDATE_REPORTING_REASONS_ASYNC,
} from './constants'

export const getReportingReasons = (locale) => ({
  type: GET_REPORTING_REASONS_ASYNC.INITIATE,
  payload: { locale },
})
const getReportingReasonsCancel = () => ({
  type: GET_REPORTING_REASONS_ASYNC.CANCEL,
})
export const getReportingReasonsSuccess = (data) => ({
  type: GET_REPORTING_REASONS_ASYNC.SUCCESS,
  payload: { data },
})
export const getReportingReasonsError = (error) => ({
  type: GET_REPORTING_REASONS_ASYNC.ERROR,
  error,
})

const updateReportingReasons = (data, locale) => ({
  type: UPDATE_REPORTING_REASONS_ASYNC.INITIATE,
  payload: { data, locale },
})
const updateReportingReasonsCancel = () => ({
  type: UPDATE_REPORTING_REASONS_ASYNC.CANCEL,
})
export const updateReportingReasonsSuccess = () => ({
  type: UPDATE_REPORTING_REASONS_ASYNC.SUCCESS,
})
export const updateReportingReasonsError = (error) => ({
  type: UPDATE_REPORTING_REASONS_ASYNC.ERROR,
  error,
})

const restoreDefaultReasons = (locale) => ({
  type: RESTORE_DEFAULT_REASONS_ASYNC.INITIATE,
  payload: { locale },
})
const restoreDefaultReasonsCancel = () => ({
  type: RESTORE_DEFAULT_REASONS_ASYNC.CANCEL,
})
export const restoreDefaultReasonsSuccess = () => ({
  type: RESTORE_DEFAULT_REASONS_ASYNC.SUCCESS,
})
export const restoreDefaultReasonsError = (error) => ({
  type: RESTORE_DEFAULT_REASONS_ASYNC.ERROR,
  error,
})

export default {
  // to props
  getReportingReasons,
  getReportingReasonsCancel,
  updateReportingReasons,
  updateReportingReasonsCancel,
  restoreDefaultReasons,
  restoreDefaultReasonsCancel,
}
